import { useTranslation as ut } from 'react-i18next';
export const useTranslation = (value: string | undefined | string[]) => {
  const { t: translation, ...rest } = ut(value);
  function t(key: unknown, options?: Record<string, string> | undefined) {
    if (!key || typeof key !== 'string') return '';
    return translation(key, options);
  }
  return { t, ...rest };
};
